import {createLayer, materialSelectionPatch, FINISHES, PATTERNS} from './design-model.js';
import {PHOTO_GELS, PHOTO_DECORATIONS} from './photo-catalog.js';

// A photo supplies a new base color, independent of the previous gel texture
// or its adjustments. Keep authored artwork and all untargeted nails intact.
export function applyPhotoPalette(design, indices, hexes) {
 if(!Array.isArray(hexes)||!hexes.length||!hexes.every(hex=>typeof hex==='string'&&/^#[0-9a-f]{6}$/i.test(hex)))throw new Error('请先从照片中选择有效颜色');
 const targets=[...new Set(indices)].filter(i=>Number.isInteger(i)&&i>=0&&i<10);
 if(!targets.length)return design;
 const colors=new Map(targets.map((index,order)=>[index,hexes[order%hexes.length].toLowerCase()]));
 return {...design,nails:design.nails.map((n,index)=>colors.has(index)?{
  ...n,customColor:colors.get(index),opacity:1,adjust:{hue:0,saturation:100,brightness:100},
  finish:n.finish==='french'?'french':'glossy',gradient:{...n.gradient,enabled:false},catEye:{...n.catEye,enabled:false}
 }:n)};
}

// Clicks act on the selection; a drop passes exactly one target. Each nail owns
// its layers, so batch removal must match the effect, never another nail's ID.
export function applyStudioEffect(design, indices, action, {toggle=true}={}) {
 const targets=[...new Set(indices)].filter(i=>Number.isInteger(i)&&i>=0&&i<10);
 if(!targets.length||!action)return design;
 const result=structuredClone(design), nails=targets.map(i=>result.nails[i]);
 const assign=fn=>nails.forEach(n=>Object.assign(n,fn(n)));
 if(action.kind==='solid-color') {
  if(typeof action.color!=='string'||!/^#[0-9a-f]{6}$/i.test(action.color))return design;
  const color=action.color.toLowerCase();
  assign(n=>action.secondary?{gradient:{...n.gradient,enabled:true,materialId:null,color}}:{
   customColor:color,opacity:1,adjust:{hue:0,saturation:100,brightness:100},
   finish:n.finish==='french'?'french':'glossy',gradient:{...n.gradient,enabled:false},catEye:{...n.catEye,enabled:false}
  });
 } else if(action.kind==='material') {
  const material=PHOTO_GELS.find(c=>c.id===action.id);if(!material)return design;
  assign(n=>action.secondary?{gradient:{...n.gradient,enabled:true,materialId:material.id,color:material.hex}}:{...materialSelectionPatch(n,material),opacity:n.opacity===0?1:n.opacity});
 } else if(action.kind==='finish'&&FINISHES.some(f=>f.id===action.id)) {
  assign(n=>({finish:action.id,catEye:{...n.catEye,enabled:false},french:{...n.french,enabled:false}}));
 } else if(action.kind==='gradient') {
  const enabled=!(toggle&&nails.every(n=>n.gradient.enabled));assign(n=>({gradient:{...n.gradient,enabled}}));
 } else if(action.kind==='french'&&['classic','deep','v','diagonal','thin','heart','flat'].includes(action.id)) {
  const enabled=!(toggle&&nails.every(n=>n.french.enabled&&n.french.mode===action.id));
  assign(n=>({french:{...n.french,mode:action.id,enabled},...(!enabled&&n.finish==='french'?{finish:'glossy'}:{})}));
 } else {
  let patch,match,kind=action.kind;
  if(kind==='pattern'&&PATTERNS.some(p=>p.id===action.id)) {
   patch={type:action.id,color:action.color||'#ffffff',strokeWidth:action.width||2,clip:true,...(action.id==='dots'?{dotDensity:action.dotDensity,dotSize:action.dotSize}:{})};match=l=>l.kind===kind&&l.type===action.id;
  } else if(kind==='charm') {
   const item=PHOTO_DECORATIONS.find(d=>d.id===action.id);if(!item)return design;
   patch={type:item.id,sizeMm:item.defaultSize||3,color:item.color||'#d4b170',clip:false};match=l=>l.kind===kind&&l.type===item.id;
  } else if(kind==='sticker'&&design.assets[action.id]) {
   patch={assetId:action.id,clip:false};match=l=>l.kind===kind&&l.assetId===action.id;
  } else return design;
  const visible=l=>match(l)&&l.visible!==false&&l.opacity!==0;
  const remove=toggle&&nails.every(n=>n.layers.some(visible));
  if(!remove&&nails.some(n=>!n.layers.some(visible)&&n.layers.length>=80))throw new Error('甲片图层已满，请先整理图层');
  nails.forEach(n=>{if(remove)n.layers=n.layers.filter(l=>!match(l));else if(!n.layers.some(visible))n.layers.push(createLayer(kind,{x:50,y:75,scale:1,rotation:0,opacity:1,visible:true,...patch}));});
 }
 return result;
}
